import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rmsMap',
    standalone: false
})
export class RmsMapPipe implements PipeTransform {

  transform<Input, Output>(value: Array<Input>, mapFn: (a: Input) => Output): Array<Output> {
    return value.map(x => mapFn(x));
  }

}
